<template>
  <div class="avatar">
    <img
      class="avatar-style"
      :src="require('@/assets/images/man-avatar.png')"
      alt=""
    />
    <div class="avatar-name-panel pl-2">
      <span class="avatar-fullname"
        >{{ firstName ? firstName : 'John' }}
        {{ middleName ? middleName : '' }}
        {{ lastName ? lastName : 'Doe' }}</span
      >
      <span class="avatar-user-type">{{
        userType ? 'Parent' : 'Individual'
      }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "ImageCell",
  props: {
    detail: {
      type: [Array, Object],
      required: false
    }
  },
  mounted () {
    if (this.params) {
      this.firstName = this.params.data.lead_first_name
      this.middleName = this.params.data.lead_middle_name
      this.lastName = this.params.data.lead_last_name
      this.userType = this.params.data['User Type']
    } else {
      this.firstName = this.detail.lead_first_name
      this.middleName = this.detail.lead_middle_name
      this.lastName = this.detail.lead_last_name
      this.userType = this.detail.multi_user
    }
  },
  data () {
    return {
      firstName: "",
      middleName: "",
      lastName: "",
      userType: ""
    }
  },
  watch: {
    detail (newVal) {
      this.firstName = newVal.lead_first_name
      this.middleName = newVal.lead_middle_name
      this.lastName = newVal.lead_last_name
      this.userType = newVal.multi_user
    },
  }
};
</script>
<style>
.avatar {
  display: flex;
  align-items: center;
}
.ag-theme-material .ag-cell {
  line-height: unset !important;
}
.avatar-style {
  width: 30px;
  height: auto;
  border-radius: 50%;
  align-items: center;
}
.avatar-name-panel {
  display: flex;
  flex-direction: column;
}
.avatar-fullname {
  font-family: 'Montserrat' !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  color: rgba(28,29,34,1) !important;
}
.avatar-user-type {
  font-family: 'Montserrat' !important;
  font-size: 12px !important;
  font-weight: 400px !important;
  color: #797979 !important;
}
</style>
